import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    paymentOffcanvasVisible: false,
    fromState: '',
    itemSizeData: null
}

export const PaymentOffcanvasSlice = createSlice({
    name: 'payment',
    initialState,
    reducers: {
      showPaymentOffcanvas: (state, action) => {
        const {
            paymentOffcanvasVisible,
            fromState,
            itemSizeData
        } = action.payload
        state.paymentOffcanvasVisible = paymentOffcanvasVisible
        state.fromState = fromState
        state.itemSizeData = itemSizeData
      },
      hidePaymentOffcanvas: (state) => {
        state.paymentOffcanvasVisible = false
      }
    }
})

export const { showPaymentOffcanvas, hidePaymentOffcanvas } = PaymentOffcanvasSlice.actions;


export default PaymentOffcanvasSlice.reducer